export default __webpack_public_path__ + "static/media/0ae877380532ccb9e11a89a067de9c0e.svg";